import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'

export const ACCOUNTSANDLOANS_GET = 'ACCOUNTSANDLOANS_GET'
export const ACCOUNTSANDLOANS_RECEIVED = 'ACCOUNTSANDLOANS_RECEIVED'
export const ACCOUNTBALANCE_RECEIVED = 'ACCOUNTBALANCE_RECEIVED'
export const ACCOUNTSANDLOANS_BTA_RECEIVED = 'ACCOUNTSANDLOANS_BTA_RECEIVED'
export const ACCOUNTSANDLOANS_LOCK_RECEIVED = 'ACCOUNTSANDLOANS_LOCK_RECEIVED'
export const ACCOUNTSANDLOANS_GET_ERROR = 'ACCOUNTSANDLOANS_GET_ERROR'
export const ACCOUNTSANDLOANS_SET_SELECTEDACCOUNT = 'ACCOUNTSANDLOANS_SET_SELECTEDACCOUNT'

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const accountsAndLoansReceive = accountsandloans => ({
  type: ACCOUNTSANDLOANS_RECEIVED,
  accountsandloans,
})

const accountBalanceReceive = accountBalance => ({
  type: ACCOUNTBALANCE_RECEIVED,
  accountBalance,
})

const accountsAndLoansBTAAccountReceive = bankTransferAccounts => ({
  type: ACCOUNTSANDLOANS_BTA_RECEIVED,
  bankTransferAccounts,
})

const accountsAndLoansLockedAccountReceive = lockedAccounts => ({
  type: ACCOUNTSANDLOANS_LOCK_RECEIVED,
  lockedAccounts,
})

const selectedAccount = account => ({
  type: ACCOUNTSANDLOANS_SET_SELECTEDACCOUNT,
  account,
})

export function setSelectedAccount(account) {
  return (dispatch) => {
    dispatch(selectedAccount(account))
  }
}

export function getAccountsAndLoans(accountType, employeeId) {
  return (dispatch) => {
    dispatch(fetching(ACCOUNTSANDLOANS_GET))
    agent.AccountsAndLoans.list(accountType, employeeId).then((response) => {
      const accountsandloans = response.map(accountandloan => ({
        employeeId: accountandloan.employee_id,
        loginName: accountandloan.loginname,
        accountId: accountandloan.accountID,
        productType: accountandloan.ProductType,
        accountNo: (accountandloan.AccountNumber ? accountandloan.AccountNumber : accountandloan.accountNumber),
        legalName: accountandloan.LegalName,
        contract: accountandloan.Contract,
        balance: accountandloan.Balance,
        emailAddress: accountandloan.EmailAddress,
        type: accountandloan.AccountType,
      }))
      dispatch(accountsAndLoansReceive(accountsandloans))
      // dispatch(notify('Successfully load admin centre'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()        
      } else {
        dispatch(notify(description))
        // console.warn('Err <getAccountsAndLoans>: ', error)
        dispatch(fetchingerror(ACCOUNTSANDLOANS_GET_ERROR))
      }
    })
  }
}

export function getAccountBalance(accountType, accountNoOrId, employeeId) {
  return (dispatch) => {
    dispatch(fetching(ACCOUNTSANDLOANS_GET))
    agent.AccountsAndLoans.details(accountType, accountNoOrId, employeeId).then((response) => {
      let accountBalance = {}
      if (response.length > 0) {
        accountBalance = {
          employeeId: response[0].employee_id,
          loginName: response[0].loginname,
          accountId: response[0].accountID,
          productType: response[0].ProductType,
          accountNo: (response[0].AccountNumber ? response[0].AccountNumber : response[0].accountNumber),
          legalName: response[0].LegalName,
          contract: response[0].Contract,
          balance: response[0].Balance,
          emailAddress: response[0].EmailAddress,
          type: response[0].AccountType,
        }
      }
      /* let accountBalance= []
      if (response.length > 0) {
        accountBalance = response.map(account => ({
          employeeId: account.employee_id,
          loginName: account.loginname,
          accountId: account.accountID,
          productType: (account.ProductType ? account.AccountType : ''),
          accountNo: (account.AccountNumber ? account.AccountNumber : account.accountNumber),
          legalName: account.LegalName,
          contract: account.Contract,
          balance: account.Balance,
          emailAddress: account.EmailAddress,
        }))
      } */
      dispatch(accountBalanceReceive(accountBalance))
      // dispatch(notify('Successfully load admin centre'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getAccountBalance>: ', error)
        dispatch(fetchingerror(ACCOUNTSANDLOANS_GET_ERROR))
      }
    })
  }
}

export function getBankTransferAccounts(employeeId) {
  return (dispatch) => {
    dispatch(fetching(ACCOUNTSANDLOANS_GET))
    agent.AccountsAndLoans.listbanktransferaccount(employeeId).then((response) => {
      const accountsandloans = response.map(accountandloan => ({
        employeeId: accountandloan.employee_id,
        loginName: accountandloan.loginname,
        accountId: accountandloan.accountID,
        productType: accountandloan.ProductType,
        accountNo: accountandloan.AccountNumber,
        legalName: accountandloan.LegalName,
        contract: accountandloan.Contract,
        balance: accountandloan.Balance,
        emailAddress: accountandloan.EmailAddress,
        partnerName: accountandloan.PartnerName,
      }))
      dispatch(accountsAndLoansBTAAccountReceive(accountsandloans))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getBankTransferAccounts>: ', error)
        dispatch(fetchingerror(ACCOUNTSANDLOANS_GET_ERROR))
      }
    })
  }
}

export function getLockedAccounts(employeeId) {
  return (dispatch) => {
    dispatch(fetching(ACCOUNTSANDLOANS_GET))
    agent.AccountsAndLoans.listlockedaccount(employeeId).then((response) => {
      dispatch(accountsAndLoansLockedAccountReceive(response))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getLockedAccounts>: ', error)
        dispatch(fetchingerror(ACCOUNTSANDLOANS_GET_ERROR))
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/accountsAndLoans.js